<template>
  <div class="legal-wrap" :class="isZh ? 'lang-cn' : 'lang-it'">
    <Head></Head>
    <div class="page">
      <div class="doc-header">
        <!-- 法律申明 -->
        <h1 class="doc-title doc-title-single">
          {{ $fanyi("法律申明") }}
        </h1>
        <div class="doc-sub">
          ADVANCING DIGITAL TRADE CO., LIMITED · www.rakumart.it
        </div>
      </div>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">1</span>
          <span class="t">
            <span class="it">Dati identificativi</span>
            <span class="cn">身份识别信息</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            In conformità con l'obbligo di informazione previsto dall'articolo
            10 della Legge 34/2002 dell'11 luglio, relativa ai Servizi della
            Società dell'Informazione e del Commercio Elettronico, si informa
            che il titolare del dominio web è ADVANCING DIGITAL TRADE CO.,
            LIMITED (di seguito, "rakumart.it"), e-mail:
            <a href="mailto:service@rakumart.it">service@rakumart.it</a>.
          </p>
          <p class="cn">
            根据 7 月 11 日第 34/2002 号《信息社会服务和电子商务法》第 10
            条规定的信息义务，特此告知本网站域名的所有者为 ADVANCING DIGITAL TRADE
            CO., LIMITED（以下简称
            "rakumart.it"），电子邮箱：service@rakumart.it。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">2</span>
          <span class="t">
            <span class="it">Utenti</span>
            <span class="cn">用户</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            L'accesso e/o l'utilizzo di questo portale attribuisce la qualifica
            di UTENTE, il quale accetta, a partire da tale accesso e/o utilizzo,
            le presenti Condizioni Generali d'Uso. Tali condizioni si applicano
            indipendentemente dalle eventuali Condizioni Generali di Contratto
            obbligatorie.
          </p>
          <p class="cn">
            访问和/或使用本门户网站即赋予用户身份，用户自该访问和/或使用之时起即接受本《通用使用条款》。无论是否存在其他具有强制约束力的《通用合同条款》，本条款均适用。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">3</span>
          <span class="t">
            <span class="it">Utilizzo del portale</span>
            <span class="cn">门户网站的使用</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il sito www.rakumart.it consente l'accesso a numerose informazioni,
            servizi, programmi o dati (di seguito "contenuti") presenti su
            Internet e appartenenti al TITOLARE. L'UTENTE si assume la
            responsabilità dell'utilizzo del portale.
          </p>
          <p class="cn">
            网站 www.rakumart.it
            提供对互联网上属于所有者的大量信息、服务、程序或数据（以下简称
            "内容"）的访问。用户须自行承担使用本门户网站的责任。
          </p>
        </div>
        <div class="bi">
          <p class="it lead">
            L'UTENTE si impegna a fornire informazioni veritiere e lecite quando
            richiesto e a utilizzare diligentemente i contenuti e le
            informazioni disponibili sul portale, evitando di:
          </p>
          <p class="cn">
            用户承诺在被要求时提供真实合法的信息，并谨慎使用门户网站上提供的内容和信息，避免：
          </p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >svolgere attività illecite, illegali o contrarie alla buona fede
              e all'ordine pubblico;</span
            >
            <span class="cn"
              >从事非法、违法或违背诚信原则及公共秩序的活动；</span
            >
          </li>
          <li>
            <span class="it"
              >diffondere contenuti razzisti, xenofobi, pornografici illegali o
              lesivi dei diritti umani;</span
            >
            <span class="cn"
              >传播种族主义、仇外、非法色情或侵害人权的内容；</span
            >
          </li>
          <li>
            <span class="it"
              >provocare danni ai sistemi fisici o informatici del TITOLARE o di
              terzi;</span
            >
            <span class="cn">对所有者或第三方的物理或信息系统造成损害；</span>
          </li>
          <li>
            <span class="it"
              >tentare di accedere agli account e-mail di altri utenti.</span
            >
            <span class="cn">试图访问其他用户的电子邮箱账户。</span>
          </li>
        </ul>
        <div class="bi">
          <p class="it">
            Il TITOLARE si riserva il diritto di rimuovere contenuti non
            appropriati.
          </p>
          <p class="cn">所有者保留删除不当内容的权利。</p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">4</span>
          <span class="t">
            <span class="it">Protezione dei dati</span>
            <span class="cn">数据保护</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il TITOLARE rispetta la normativa spagnola in materia di protezione
            dei dati personali e garantisce il corretto utilizzo e trattamento
            dei dati dell'utente.
          </p>
          <p class="cn">
            所有者遵守西班牙有关个人数据保护的法规，并保证对用户数据进行正确的使用和处理。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Maggiori informazioni sono disponibili nella nostra Informativa
            sulla Privacy.
          </p>
          <p class="cn">更多信息请参阅我们的《隐私政策》。</p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">5</span>
          <span class="t">
            <span class="it">Proprietà intellettuale e industriale</span>
            <span class="cn">知识产权与工业产权</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il TITOLARE è titolare di tutti i diritti di proprietà intellettuale
            e industriale del sito web e dei contenuti presenti sul sito.
          </p>
          <p class="cn">
            所有者拥有本网站及网站内所有内容的全部知识产权和工业产权。
          </p>
        </div>
        <div class="bi">
          <p class="it">Tutti i diritti sono riservati.</p>
          <p class="cn">保留所有权利。</p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">6</span>
          <span class="t">
            <span class="it">Politica dei cookie</span>
            <span class="cn">Cookie 政策</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            L'azienda informa sulla propria politica relativa ai cookie in
            conformità con la normativa vigente.
          </p>
          <p class="cn">公司依据现行法规告知其有关 Cookie 的政策。</p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">7</span>
          <span class="t">
            <span class="it">Esclusione di garanzie e responsabilità</span>
            <span class="cn">担保与责任的免除</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il TITOLARE non sarà responsabile per eventuali danni derivanti da
            errori nei contenuti, indisponibilità del portale o trasmissione di
            virus.
          </p>
          <p class="cn">
            所有者对因内容错误、门户网站不可用或病毒传播所造成的任何损害不承担责任。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">8</span>
          <span class="t">
            <span class="it">Modifiche</span>
            <span class="cn">修改</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il TITOLARE si riserva il diritto di apportare modifiche al portale
            senza preavviso.
          </p>
          <p class="cn">
            所有者保留在不事先通知的情况下对门户网站进行修改的权利。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">9</span>
          <span class="t">
            <span class="it">Link</span>
            <span class="cn">链接</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il TITOLARE non è responsabile dei contenuti di siti web esterni
            collegati tramite link.
          </p>
          <p class="cn">所有者对通过链接连接的外部网站的内容不承担责任。</p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">10</span>
          <span class="t">
            <span class="it">Diritto di esclusione</span>
            <span class="cn">排除权</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il TITOLARE si riserva il diritto di negare o revocare l'accesso
            agli utenti che violino le presenti condizioni.
          </p>
          <p class="cn">所有者保留拒绝或撤销违反本条款用户访问权限的权利。</p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">11</span>
          <span class="t">
            <span class="it">Disposizioni generali</span>
            <span class="cn">一般规定</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il TITOLARE perseguirà qualsiasi utilizzo improprio del portale.
          </p>
          <p class="cn">所有者将追究对门户网站的任何不当使用。</p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">12</span>
          <span class="t">
            <span class="it">Modifica delle condizioni e durata</span>
            <span class="cn">条款修改与有效期</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il TITOLARE può modificare in qualsiasi momento le presenti
            condizioni.
          </p>
          <p class="cn">所有者可随时修改本条款。</p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">13</span>
          <span class="t">
            <span class="it">Legge applicabile e foro competente</span>
            <span class="cn">适用法律与管辖法院</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il rapporto tra il TITOLARE e l'UTENTE sarà regolato dalla normativa
            italiana vigente.
          </p>
          <p class="cn">所有者与用户之间的关系受现行意大利法律管辖。</p>
        </div>
        <div class="bi">
          <p class="it">
            Qualsiasi controversia sarà sottoposta ai Tribunali della città di
            Roma.
          </p>
          <p class="cn">任何争议均应提交罗马市法院处理。</p>
        </div>
      </section>
    </div>
    <Foot style="width: 100%"></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/HomePageTop.vue";
import Foot from "@/components/foot/Foot.vue";
export default {
  data() {
    return {};
  },
  components: { Head, Foot },
  computed: {
    isZh() {
      return !!this.$store.state.fanyi;
    },
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

$accent: #009246;

.legal-wrap {
  background: #f4f6f9;
  padding: 0 0 60px;

  &.lang-it .cn {
    display: none !important;
  }

  &.lang-cn .it {
    display: none !important;
  }
}

.page {
  width: 900px;
  margin: 30px auto 60px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(20, 30, 60, 0.07);
  padding: 50px 60px 56px;
}

.doc-header {
  text-align: center;
  padding-bottom: 26px;
  border-bottom: 2px solid #f0f2f5;
  margin-bottom: 34px;

  .doc-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;

    // $fanyi 单行标题（与 Condizioni-generali / Informativa-sulla-privacy 一致）
    &.doc-title-single {
      display: block;
      font-size: 30px;
      font-weight: 700;
      color: #1d2129;
      line-height: 1.2;
      text-align: center;
      margin: 0;
    }

    // 标题中意文样式一致（lang-cn 下仅显示 .cn）
    span.it,
    span.cn {
      font-size: 30px;
      font-weight: 700;
      color: #1d2129;
      line-height: 1.2;
    }
  }

  .doc-sub {
    margin-top: 14px;
    font-size: 13px;
    color: #a0a8b5;
    letter-spacing: 0.5px;
  }
}

.sec {
  margin-bottom: 30px;

  .sec-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .num {
      flex: 0 0 34px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      border-radius: 9px;
      background: $accent;
      color: #fff;
      font-size: 15px;
      font-weight: 700;
      margin-right: 14px;
    }

    .t {
      display: flex;
      flex-direction: column;

      .it {
        font-size: 18px;
        font-weight: 700;
        color: #1d2129;
        line-height: 1.3;
      }

      .cn {
        font-size: 13px;
        color: #86909c;
      }
    }
  }
}

.bi {
  margin-bottom: 14px;

  .it {
    font-size: 14.5px;
    line-height: 1.75;
    color: #2b303a;
    margin-bottom: 6px;

    &.lead {
      font-weight: 600;
    }

    a {
      color: $accent;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .cn {
    font-size: 13.5px;
    line-height: 1.75;
    color: #86909c;
  }
}

.bi-list {
  margin: 0 0 18px;
  padding: 0;

  li {
    position: relative;
    list-style: none;
    padding: 10px 16px 10px 30px;
    border-radius: 8px;
    margin-bottom: 8px;
    background: #f7f8fa;

    &::before {
      content: "";
      position: absolute;
      left: 14px;
      top: 19px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: $accent;
    }

    .it {
      display: block;
      font-size: 14px;
      line-height: 1.7;
      color: #2b303a;
    }

    .cn {
      display: block;
      font-size: 13px;
      line-height: 1.7;
      color: #86909c;
      margin-top: 2px;
    }
  }
}
</style>
